import {
  Wrap,
  Inner,
  Head,
  Title,
  Sub,
  Grid,
  Block,
  BlockTitle,
  List,
  Item,
  Key,
  Val,
  Actions,
  Btn,
  Note,
} from "./ContactInfoStyles";

const toTel = (n) => (n || "").replace(/[^\d+]/g, "");

export default function ContactInfo({
  brand = "Ahava Cakes",
  address,
  mapsUrl,
  phones = [],
  email,
  schedule = [],
  note,
}) {
  const phoneList = (phones || []).filter(Boolean);

  return (
    <Wrap aria-label="Informații de contact">
      <Inner itemScope itemType="https://schema.org/Bakery">
        <Head>
          <Title itemProp="name">{brand}</Title>
          <Sub>Detalii • Program • Locație</Sub>
        </Head>

        <Grid>
          {/* PROGRAM */}
          <Block>
            <BlockTitle>Program</BlockTitle>
            <List>
              {schedule.map((row) => (
                <Item key={row.k}>
                  <Key>{row.k}</Key>
                  <Val>{row.v}</Val>
                </Item>
              ))}
            </List>
          </Block>

          {/* ADRESA */}
          <Block
            itemProp="address"
            itemScope
            itemType="https://schema.org/PostalAddress"
          >
            <BlockTitle>Adresă</BlockTitle>
            <List>
              <Item>
                <Key>Locație</Key>
                {/* aici permitem wrap */}
                <Val $wrap itemProp="streetAddress">
                  {address}
                </Val>
              </Item>
            </List>

            <Actions>
              <Btn href={mapsUrl} target="_blank" rel="noopener">
                Deschide în Maps
              </Btn>
            </Actions>
          </Block>

          {/* CONTACT */}
          <Block>
            <BlockTitle>Contact</BlockTitle>
            <List>
              {phoneList.map((num, i) => (
                <Item key={`${num}-${i}`}>
                  <Key>{i === 0 ? "Telefon" : ""}</Key>
                  <Val>
                    <a itemProp="telephone" href={`tel:${toTel(num)}`}>
                      {num}
                    </a>
                  </Val>
                </Item>
              ))}

              {email && (
                <Item>
                  <Key>Email</Key>
                  <Val>
                    <a itemProp="email" href={`mailto:${email}`}>
                      {email}
                    </a>
                  </Val>
                </Item>
              )}
            </List>

            {note && <Note>{note}</Note>}
          </Block>
        </Grid>
      </Inner>
    </Wrap>
  );
}
